import { useState } from 'react'
import useResizeObserver from './useResizeObserver'

export default function useResizeObserverFromRef<T extends HTMLElement>(
  callback: (element: T) => void
): (element: T) => void {
  const [element, setElement] = useState<T | null>(null)

  useResizeObserver(element, () => element && callback(element))

  return setElement
}
